export default __webpack_public_path__ + "static/media/check.0ac86731.svg";